import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { getLandingPathForRole } from '../../utils/roleUtils';

/**
 * LoginRouteGuard - Redirects authenticated users away from login page
 * to their role-based landing page
 */
const LoginRouteGuard = ({ children }) => {
  const context = useContext(UserContext) || {};
  const { user, loadingUser } = context;
  const location = useLocation();

  // If still loading user, show nothing (login page will handle its own loading)
  if (loadingUser) {
    return children;
  }

  // If user is authenticated, redirect to their role-based landing page
  if (user) {
    const landingPath = getLandingPathForRole(user?.role);
    return <Navigate to={landingPath} replace state={{ from: location }} />;
  }

  // User is not authenticated, show login page
  return children;
};

export default LoginRouteGuard;

